import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    onMounted,
} from '@vue/composition-api';

import { CompetitionsUIStore } from '@sportOfferFederation/competitions/store/ui';
import { AvailableCompetitionTabs } from '@sportOfferFederation/competitions/store/ui/types';
import { ExpandedEventInUrl } from '@app/enums';

export function useCompetitionTabs() {
    const { route } = useVueRouter();
    const competitionsStore = useVuexStore<CompetitionsUIStore>('ui/competitions');

    const selectedTab = competitionsStore.state('selectedTab');
    const setSelectedTab = competitionsStore.action('setSelectedTab');

    const initialRouteTab = computed(() => {
        return route.value.query?.[ExpandedEventInUrl.competitionTab] as AvailableCompetitionTabs
            || AvailableCompetitionTabs.Matches;
    });

    onMounted(() => {
        if (initialRouteTab.value !== selectedTab.value) {
            setSelectedTab(initialRouteTab.value as AvailableCompetitionTabs);
        }
    });

    return {
        availableTabs: competitionsStore.getter('availableTabs'),
        initialRouteTab,
        selectedTab,
        setSelectedTab,
    };
}
